import React from 'react';
import { Box, Zoom, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export const SuccessMessage = ({ isSuccess }) => {
  // Define the font style to keep the code clean
  const openSansStyle = {
    fontFamily: '"Open Sans", sans-serif',
  };

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        gap: 2, 
        mt: 4 
      }}
    >
      <Zoom in={isSuccess} timeout={500}>
        <Box sx={{ textAlign: 'center' }}>
          {/* Icon with custom hex color */}
          <CheckCircleIcon 
            sx={{ 
              fontSize: 72, 
              color: '#e48c80' 
            }} 
          />

          {/* Green text with Open Sans */}
          <Typography 
            variant="h5" 
            sx={{ 
              ...openSansStyle,
              fontWeight: 700, 
              color: '#000000', // A standard green or use 'success.main'
              mt: 1 
            }}
          >
            Success
          </Typography>

          <Typography 
            variant="body1" 
            sx={{ 
              ...openSansStyle,
              color: '#000000' 
            }}
          >
            Your authentication was successful, you may proceed further.
          </Typography>
        </Box>
      </Zoom>
    </Box>
  );
};